export const preferredDateFormatOptions: any[] = [
  { value: 0, label: "Use System Default" },
  { value: 1, label: "2023-06-16 7:37 ()" },
  { value: 2, label: "2023-06-16 7:37 (iso)" },
  { value: 3, label: "16-06-2023 7:37 (eu)" },
  { value: 4, label: "06/16/2023 7:37 AM (us)" },
  { value: 5, label: "16/06/2023 7:37 AM (ve)" },
  { value: 6, label: "16.06.2023 7:37 AM (int)" },
  { value: 7, label: "16-Jun-2023 7:37 AM (id)" },
  { value: 8, label: "16.06.2023 7:37 (ch)" }
]

export const merticsSystemOptions: any[] = [
  { value: "Metric 2.480,12", label: "Metric 2.480,12" },
  { value: "Imperial 2,480.12", label: "Imperial 2,480.12" },
]
